import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { INVOICE_TYPES } from '../../Invoices/constants';
import { Card } from '../../../components/Card';
import { List, Row, Cell } from '../../../components/List';
import { setNewInvoiceValue } from '../../Invoices/actions';
import { selectInvoice, selectNewInvoice } from '../../Invoices/selectors';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { FormField } from '../../../components/FormFields';
import { Checkbox } from '../../../components/Checkbox';
import { VehicleInvoiceCard } from '../../Invoices/components/IncomingInvoice/CardVehicleInfo';
import { getDate } from '../../Vehicles/helpers';
import { Calendar } from '../../../components/Icon';
import cn from 'classnames';
import styles from './ProductInvoiceInfoCard.module.css';

dayjs.extend(customParseFormat);

const Container = styled.div`
  width: 100%;
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }

  .status-block {
    width: fit-content;
  }
  .info-card.fixedWeight {
    width: 98%;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class ProductInvoiceInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.types?.map(type => {
      let value = this.props.invoice[type];
      if (type === 'date' && this.props.invoice?.type !== INVOICE_TYPES.CREDIT) {
        value = getDate(this.props.invoice?.createdAt);
      }
      this.props.setValue(value, type);
    });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.vehicle[fieldName];
  }

  datePicker(type) {
    let format = this.props.values[type] == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.values[type] && dayjs(this.props.values[type], format);
    return (
      <FormField>
        <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
          <DatePicker
            dateFormat="dd-MM-yyyy"
            selected={selected && selected.toDate()}
            onChange={date => {
              let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
              this.props.setValue(d, type);
            }}
          />
          <Calendar className={styles.iconCalendar} />
        </div>
      </FormField>
    );
  }

  input(type, disabled) {
    const value =
      typeof this.props.values[type] == 'string'
        ? parseFloat(this.props.values[type]?.replace(',', '.'))
        : this.props.values[type] || 0;

    let inputValue = this.props.values[type];

    if (type == 'date') {
      let rawDate = this.props.values['date'];
      inputValue = getDate(rawDate);
    }

    return (
      <div>
        {' '}
        <input
          className="form-control"
          key={this.props.type}
          disabled={disabled}
          value={inputValue}
          onChange={evt => this.props.setValue(evt.target.value, type)}
        />
      </div>
    );
  }

  render() {
    return (
      <Container>
        <Card className="vehicle-info-card info-card info fixedWeight">
          <List>
            <Row>
              <Cell>{this.lbl('invoice.create.date')}</Cell>
              <Cell className="field-cell">{this.input('date', 'disabled')}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('invoice.create.dueDate')}</Cell>
              <Cell className="field-cell">{this.datePicker('dueDate')}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('invoice.create.paidDate')}</Cell>
              <Cell className="field-cell">{this.datePicker('paidDate')}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('invoice.create.financialTotalAmount')}</Cell>
              <Cell className="field-cell">{this.input('financialTotalAmount', 'disabled')}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl(`invoice.create.finalized`)}</Cell>
              <Cell className="field-cell">
                <Checkbox disabled={true} checked={this.props.invoice?.isFinal} />
              </Cell>
            </Row>
          </List>
        </Card>
        {this.vehicle?.id && <VehicleInvoiceCard vehicle={this.vehicle} productOverview />}
      </Container>
    );
  }
}

ProductInvoiceInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    values: selectNewInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoiceInfoCard = compose(withConnect, withRouter)(ProductInvoiceInfoCardComp);
